import { create } from 'zustand'
import { IBankAccount } from './BankAccount/interface'
import { createBankAccountSlice } from './BankAccount/index'
import { IMyBalance } from './MyBalance/interface'
import { createMyBalanceSlice } from './MyBalance/index'
import { IWithdrawal } from './Withdrawal/interface'
import { createWithdrawalSlice } from './Withdrawal/index'
import { IWithdrawHistory } from './WithdrawHistory/interface'
import { createWithdrawHistorySlice } from './WithdrawHistory/index'
import { IBankAccountVerify } from './BankAccountVerification/interface'
import { createBankAccountVerifySlice } from './BankAccountVerification/index'
import { IBankList } from './BankList/interface'
import { createBankListSlice } from './BankList/index'

export const useBoundBalanceStore = create<
  IMyBalance &
    IWithdrawal &
    IBankAccount &
    IWithdrawHistory &
    IBankAccountVerify &
    IBankList
>()((...a) => ({
  ...createMyBalanceSlice(...a),
  ...createWithdrawalSlice(...a),
  ...createBankAccountSlice(...a),
  ...createWithdrawHistorySlice(...a),
  ...createBankAccountVerifySlice(...a),
  ...createBankListSlice(...a),
}))
